import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useWorkHourModel } from "../workHourModel";

export default () => {
    const {
    } = useWorkHourModel();
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}